// Slick hides slides with aria-hidden but leaves their links in the tab order.
export const observeCarouselAccessibility = root => {
  const originalTabIndexes = new Map()
  const selector =
    'a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]'
  const update = () => {
    root.querySelectorAll(".slick-slide").forEach(slide => {
      const hidden = slide.getAttribute("aria-hidden") === "true"
      slide.toggleAttribute("inert", hidden)
      slide.querySelectorAll(selector).forEach(element => {
        if (hidden) {
          if (!originalTabIndexes.has(element)) {
            originalTabIndexes.set(element, element.getAttribute("tabindex"))
          }
          if (element.getAttribute("tabindex") !== "-1")
            element.setAttribute("tabindex", "-1")
        } else if (originalTabIndexes.has(element)) {
          const value = originalTabIndexes.get(element)
          if (value === null) element.removeAttribute("tabindex")
          else element.setAttribute("tabindex", value)
          originalTabIndexes.delete(element)
        }
      })
    })
    for (const element of originalTabIndexes.keys()) {
      if (!root.contains(element)) originalTabIndexes.delete(element)
    }
  }
  const observer = new MutationObserver(update)
  observer.observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-hidden", "tabindex"],
  })
  update()
  return () => {
    observer.disconnect()
    originalTabIndexes.forEach((value, element) => {
      if (value === null) element.removeAttribute("tabindex")
      else element.setAttribute("tabindex", value)
    })
    root
      .querySelectorAll(".slick-slide[inert]")
      .forEach(slide => slide.removeAttribute("inert"))
  }
}
